import React from "react";
import "./DetailNews.css";
import { useParams } from "react-router-dom";
import { detailNews } from "../../data-news";
import { Link } from "react-router-dom";
function DetailNews() {
  const { id } = useParams();
  const newsItem = detailNews.find((item) => item.id === parseInt(id));

  // Handle case where newsItem is not found
  if (!newsItem) {
    return (
      <div>
        <h2>News item not found.</h2>
      </div>
    );
  } 

  return (
    <div>
      <div
        className="header-detail-news"
        style={{ backgroundColor: newsItem.bg_color }}
      >
        <div className="text-type-header-detail">{newsItem.type}</div>
      </div>
      <div className="section-row">
        <div>
          <Link
            to={{
              pathname: "/news&events",
            }}
            state={{ selectedType: newsItem.type }}
            style={{
              textDecoration: "none",
              cursor: "pointer",
              color: "black",
            }}
          >
            {newsItem.type}
          </Link>
        </div>
        <div>{">"}</div>
        <div>{newsItem.section}</div>
      </div>
      <div className="content-detail-news">
        <div className="content-detail-news-section">
          <div className="content-header-detail-news">{newsItem.section}</div>
          <div className="content-sub-detail-news">
            <div>{newsItem.author}</div>
            <div>{"|"}</div>
            <div>{newsItem.date}</div>
          </div>
        </div>
        {newsItem.header && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.header }}
          />
        )}
        {newsItem.img_1 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_1} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_1 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_1 }}
          />
        )}
        {newsItem.img_2 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_2} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_2 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_2 }}
          />
        )}
        {newsItem.img_3 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_3} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_3 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_3 }}
          />
        )}
        {newsItem.img_4 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_4} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_4 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_4 }}
          />
        )}
        {newsItem.img_5 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_5} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_5 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_5 }}
          />
        )}
        {newsItem.img_6 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_6} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_6 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_6 }}
          />
        )}
        {newsItem.img_7 && (
          <div className="img-detail-news-row">
            <img src={newsItem.img_7} alt="" className="img-detail-news" />
          </div>
        )}
        {newsItem.text_7 && (
          <div
            className="text-detail-news"
            dangerouslySetInnerHTML={{ __html: newsItem.text_7 }}
          />
        )}
        <div className="author-footer">{newsItem.author}</div>
      </div>
    </div>
  );
}

export default DetailNews;
